import type { Sort } from '@/stores/sorting';
import type { ProjectRequest, ProjectResponse } from '@/types';
import { sortToQuery } from '@/utils/misc';
import type { AxiosInstance, AxiosResponse } from 'axios';

class ProjectService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    getPath(id?: string) {
        return id ? `/api/projects/${id}` : '/api/projects';
    }

    index(page: number, filter?: object, sort: Sort | null = null, perPage?: number) {
        return this.apiService.get(this.getPath(), {
            params: { page, per_page: perPage, ...filter, ...sortToQuery(sort) },
        });
    }

    show(id: string): Promise<AxiosResponse<ProjectResponse>> {
        return this.apiService.get(this.getPath(id));
    }

    store(request: ProjectRequest): Promise<AxiosResponse<ProjectResponse>> {
        return this.apiService.post(this.getPath(), request);
    }

    update(id: string, request: ProjectRequest): Promise<AxiosResponse<ProjectResponse>> {
        return this.apiService.put(this.getPath(id), request);
    }

    delete(id: string): Promise<AxiosResponse<void>> {
        return this.apiService.delete(this.getPath(id));
    }

    archive(id: string): Promise<AxiosResponse<ProjectResponse>> {
        return this.apiService.post(`${this.getPath(id)}/archive`);
    }

    unarchive(id: string): Promise<AxiosResponse<ProjectResponse>> {
        return this.apiService.post(`${this.getPath(id)}/unarchive`);
    }
}

export default ProjectService;
